import { STATUS_LABELS, PAYMENT_LABELS } from "@/lib/statuses";

const STATUS_STYLE = {
  order_confirmed: "text-blue-300 bg-blue-950/60 border-blue-500/40 [&_.dot]:bg-blue-400",
  order_received: "text-blue-300 bg-blue-950/60 border-blue-500/40 [&_.dot]:bg-blue-400",
  preparing: "text-amber-300 bg-amber-950/60 border-amber-500/40 [&_.dot]:bg-amber-400",
  waiting_for_driver: "text-amber-200 bg-amber-950/50 border-amber-400/40 [&_.dot]:bg-amber-300",
  driver_assigned: "text-cyan-300 bg-cyan-950/60 border-cyan-500/40 [&_.dot]:bg-cyan-400",
  driver_picked_up: "text-violet-300 bg-violet-950/60 border-violet-500/40 [&_.dot]:bg-violet-400",
  on_the_way: "text-violet-200 bg-violet-900/60 border-violet-400/40 [&_.dot]:bg-violet-300",
  arriving_soon: "text-fuchsia-300 bg-fuchsia-950/60 border-fuchsia-500/40 [&_.dot]:bg-fuchsia-400",
  ready_for_pickup: "text-lime-300 bg-lime-950/50 border-lime-500/40 [&_.dot]:bg-lime-400",
  pickup_address_sent: "text-cyan-300 bg-cyan-950/60 border-cyan-500/40 [&_.dot]:bg-cyan-400",
  customer_on_the_way: "text-violet-200 bg-violet-900/60 border-violet-400/40 [&_.dot]:bg-violet-300",
  customer_has_arrived: "text-fuchsia-300 bg-fuchsia-950/60 border-fuchsia-500/40 [&_.dot]:bg-fuchsia-400",
  customer_verified: "text-emerald-300 bg-emerald-950/60 border-emerald-500/40 [&_.dot]:bg-emerald-400",
  delivered: "text-emerald-300 bg-emerald-950/60 border-emerald-500/40 [&_.dot]:bg-emerald-400",
  order_picked_up: "text-emerald-300 bg-emerald-950/60 border-emerald-500/40 [&_.dot]:bg-emerald-400",
  cancelled: "text-red-300 bg-red-950/60 border-red-500/40 [&_.dot]:bg-red-400",
};

const PAY_STYLE = {
  verified: "text-emerald-300 bg-emerald-950/70 border-emerald-500/40",
  awaiting_verification: "text-pink-300 bg-pink-950/60 border-pink-500/40",
  rejected: "text-red-300 bg-red-950/60 border-red-500/40",
  unpaid: "text-zinc-300 bg-zinc-800/70 border-zinc-600/50",
  cash_due_delivery: "text-lime-300 bg-lime-950/50 border-lime-500/40",
  cash_due_pickup: "text-lime-300 bg-lime-950/50 border-lime-500/40",
};

export function StatusBadge({ status }) {
  const s = STATUS_STYLE[status] || STATUS_STYLE.order_confirmed;
  return (
    <span data-testid="order-status-badge"
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold border font-mono ${s}`}>
      <span className="dot h-2 w-2 rounded-full animate-pulse" />
      {STATUS_LABELS[status] || status}
    </span>
  );
}

export function PaymentBadge({ status }) {
  const s = PAY_STYLE[status] || PAY_STYLE.unpaid;
  return (
    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-bold border font-mono ${s}`}>
      {PAYMENT_LABELS[status] || status}
    </span>
  );
}
